/*
 * ============================================================
 * MODI — Before/after compare (<modi-compare>)
 * A native <input type="range"> drives the reveal, so keyboard
 * (arrow keys), touch and pointer drag all work for free and
 * the control is announced to assistive tech. The visible
 * handle/divider is decorative (pointer-events: none); the
 * range sits on top, transparent, capturing interaction.
 *
 * Optional video mode: a card with [data-compare-video] gets a
 * toggle that plays the result in motion over the compare pane.
 * Only one card plays at a time (a play broadcast pauses the
 * others), and playback is always user-initiated.
 * Custom element → Shopify theme-editor safe (re-inits on load).
 * ============================================================
 */
(function () {
  'use strict';
  if (customElements.get('modi-compare')) return;

  var PLAY_EVENT = 'modi-compare:play';

  class ModiCompare extends HTMLElement {
    connectedCallback() {
      this.range = this.querySelector('.modi-compare__range');
      this.video = this.querySelector('[data-compare-video]');
      this.toggle = this.querySelector('[data-compare-video-toggle]');

      if (this.range) {
        this._onInput = this._update.bind(this);
        this.range.addEventListener('input', this._onInput);
        this.range.addEventListener('change', this._onInput);
        this._update();
      }

      if (this.video && this.toggle) {
        this._onToggle = this._toggleVideo.bind(this);
        this._onPeerPlay = this._pauseVideo.bind(this);
        this.toggle.addEventListener('click', this._onToggle);
        document.addEventListener(PLAY_EVENT, this._onPeerPlay);
      }
    }

    disconnectedCallback() {
      if (this.range) {
        this.range.removeEventListener('input', this._onInput);
        this.range.removeEventListener('change', this._onInput);
      }
      if (this.video && this.toggle) {
        this.toggle.removeEventListener('click', this._onToggle);
        document.removeEventListener(PLAY_EVENT, this._onPeerPlay);
      }
    }

    _update() {
      var v = parseFloat(this.range.value);
      if (isNaN(v)) v = 50;
      this.style.setProperty('--pos', v + '%');
      this.setAttribute('data-pos', Math.round(v));
    }

    _toggleVideo(event) {
      event.preventDefault();
      if (this.classList.contains('is-playing')) {
        this._pauseVideo();
      } else {
        var self = this;
        document.dispatchEvent(new CustomEvent(PLAY_EVENT, { detail: this }));
        var attempt = this.video.play();
        if (attempt && attempt.then) {
          attempt.then(function () { self._setPlaying(true); }).catch(function () {});
        } else {
          this._setPlaying(true);
        }
      }
    }

    _pauseVideo(event) {
      if (event && event.detail === this) return; // our own broadcast
      if (!this.classList.contains('is-playing')) return;
      this.video.pause();
      this._setPlaying(false);
    }

    _setPlaying(on) {
      this.classList.toggle('is-playing', on);
      this.toggle.setAttribute('aria-pressed', on ? 'true' : 'false');
      var label = this.toggle.querySelector('[data-toggle-label]');
      if (label) {
        label.textContent = on
          ? this.toggle.getAttribute('data-label-stop')
          : this.toggle.getAttribute('data-label-play');
      }
    }
  }

  customElements.define('modi-compare', ModiCompare);
})();
